// ponytail: avatar color has no backend field of its own — cycle a small
// deterministic palette keyed off a hash of the name, same trick used
// elsewhere in this codebase (see admin/VerticalsPage's VERT_COLORS).
const AVATAR_PALETTE = ['#226A73', '#1A3252', '#7AB000', '#1B5860', '#10223A', '#5F9CA3'];

function hashString(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function avatarColor(name: string): string {
  if (!name) return AVATAR_PALETTE[0];
  return AVATAR_PALETTE[hashString(name) % AVATAR_PALETTE.length];
}

export function initials(name: string): string {
  const trimmed = (name || '').trim();
  if (!trimmed) return '?';
  const parts = trimmed.split(/\s+/);
  return (parts[0][0] + (parts[1]?.[0] ?? '')).toUpperCase();
}

// relativeAge renders a compact age string ("3h", "2d", "now") for card
// metadata — deliberately terser than a full date, matching the mockup.
export function relativeAge(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const diffMs = Date.now() - then;
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'now';
  if (mins < 60) return `${mins}m`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.floor(hours / 24);
  return `${days}d`;
}
